import { onDomReady } from 'Shared/utils/dom-ready';
import { IFixitAPIClient } from '@ifixit/ifixit-api-client';
import { _js } from '@ifixit/utils/localize';
import { delegate } from 'Shared/utils/delegate';

const apiClient = new IFixitAPIClient({
   origin: window.location.origin,
   // The old MooTools request class sent this on every call; it
   // feeds the varnish_requests.api.client.* stats.
   headers: { 'Api-Client': 'iFixit-Web' },
});

onDomReady(() => {
   document.querySelectorAll('.patrolItems').forEach(container => {
      delegate(container, 'click', '.revisionActionBox a', (ev, el) => {
         let buttonGroup = el.parentNode;
         let itemCount = el.dataset.acceptCount || el.dataset.denyCount;
         let isDenyButton = el.classList.contains('buttonDeny');
         ev.preventDefault();
         ev.stopPropagation();

         // Disable buttons, so user doesn't double-submit.
         disableButtons(buttonGroup);

         if (
            itemCount > 1 &&
            !confirm(
               'This action will be applied to ' +
                  itemCount +
                  ' revisions.\n\nAre you sure you want to continue?'
            )
         ) {
            enableButtons(buttonGroup);
            return;
         }

         // For deny actions, show the denial reason modal
         if (isDenyButton) {
            let patrolItem = el.closest('.patrolItems');
            let isTranslation = patrolItem && patrolItem.dataset.isTranslation === 'true';
            showDenialModal(el.getAttribute('href'), isTranslation, buttonGroup);
         } else {
            performAction(el.getAttribute('href'), el.getAttribute('edit-href'));
         }
      });
   });

   document.querySelectorAll('.js-toggle-selected').forEach(toggle => {
      toggle.addEventListener('click', function (ev) {
         let isSelected = this.classList.contains('selected');
         document
            .querySelectorAll('.js-toggle-target')
            .forEach(el => el.classList.remove('toggle-open'));
         document
            .querySelectorAll('.js-toggle-selected')
            .forEach(el => el.classList.remove('selected'));

         let target = this.parentElement.querySelector('.js-toggle-target');
         target.classList.toggle('toggle-open', !isSelected);
         this.classList.toggle('selected', !isSelected);
      });
   });

   function showDenialModal(denyUrl, isTranslation, buttonGroup) {
      let template = document.querySelector('#denial-modal-template');
      if (!template) {
         // Fallback if modal template not found - just deny without reason
         performAction(denyUrl);
         return;
      }

      void import('Shared/modal').then(({ Modal }) => {
         let modalContent = template.cloneNode(true);
         modalContent.id = '';
         modalContent.style.display = '';

         let editReasons = modalContent.querySelector('.edit-reasons');
         let translationReasons = modalContent.querySelector('.translation-reasons');
         if (isTranslation) {
            editReasons.style.display = 'none';
            translationReasons.style.display = '';
         }

         let submitBtn = modalContent.querySelector('.denial-submit-btn');
         let radioButtons = modalContent.querySelectorAll('input[name="denial_reason"]');
         let explanationTextarea = modalContent.querySelector('#denial-explanation');
         radioButtons.forEach(radio => {
            radio.addEventListener('change', () => {
               submitBtn.disabled = false;
               explanationTextarea.focus();
            });
         });

         let cancelBtn = modalContent.querySelector('.denial-cancel-btn');
         cancelBtn.addEventListener('click', () => {
            Modal.cancel();
         });

         submitBtn.addEventListener('click', () => {
            let selectedReason = modalContent.querySelector('input[name="denial_reason"]:checked');
            let explanation = modalContent.querySelector('#denial-explanation').value.trim();

            if (!selectedReason) {
               return;
            }

            let body = { reason: selectedReason.value };
            if (explanation) {
               body.explanation = explanation;
            }

            Modal.close();
            performAction(denyUrl, null, body);
         });

         Modal.open({
            type: 'element',
            element: modalContent,
            onCancel: () => {
               enableButtons(buttonGroup);
            },
         });
      });
   }

   function performAction(href, editUrl, body = null) {
      apiClient
         .post(
            href,
            'patrol.action',
            body == null
               ? undefined
               : { body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } }
         )
         .then(response => {
            if (editUrl) {
               window.location = editUrl;
            } else {
               window.location.reload();
            }
         })
         .catch(error => {
            alert(actionErrorMessage(error));
         });
   }

   // FetchError's message is response.statusText, which HTTP/2 dropped, so
   // the status code is all a failed action has left to report.
   function actionErrorMessage(error) {
      if (!(error instanceof Error)) {
         return String(error);
      }
      if (error.message) {
         return error.message;
      }
      const status = error.response?.status;
      return status
         ? _js('Something went wrong (%1). Please try again.', String(status))
         : _js('Something went wrong. Please try again.');
   }

   function disableButtons(buttonGroup) {
      [...buttonGroup.children].forEach(el => {
         el.setAttribute('disabled', true);
      });
   }

   function enableButtons(buttonGroup) {
      [...buttonGroup.children].forEach(el => {
         el.removeAttribute('disabled');
      });
   }
});
